import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TopProgress, BackArrow, InfoBlock } from "../../../../components";
import { Container } from './styles'
import { affiliateService } from "../../../../api";
import { useParams, useNavigate, Link } from "react-router-dom";
import { timeConverterMMDDYYHHMM } from "../../../../utils/dates";
import { useUi } from "../../../../context/ui.context";
import {
  StateWrapper,
  GreenDot,
  Greentext
} from "../../../Instances/styles";
import { handleStatusName } from "../../../../utils/handle-status-name";


const ConversionPage: FC = () => {
  const { conversionId } = useParams()
  const { viewAlert } = useUi()
  const [t] = useTranslation()
  const navigate = useNavigate()
  const [conversion, setConversion] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)

  const getConversionData = async () => {
    try {
      setLoading(true)
      const response = await affiliateService.getConversion(conversionId!)
      setConversion(response?.data)
    } catch (e: any) {
      viewAlert({
        severity: 'error',
        message: e?.response?.data?.detail || t("ERROR_OCCURRED")
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getConversionData()
  }, [conversionId])

  if (loading) return <TopProgress loading={loading} />

  const conversionInfoData = conversion ? [
    {
      title: t("EXTERNAL_ID"),
      value: conversion.id,
      copy: true
    },
    {
      title: t("STATUS"),
      value: '',
      custom: (
        <StateWrapper>
          <GreenDot active={conversion.status === 'approved' ? 'true' : 'false'} />
          <Greentext active={conversion.status === 'approved' ? 'true' : 'false'}>
            {handleStatusName(conversion.status, t)}
          </Greentext>
        </StateWrapper>
      )
    },
    {
      title: t("CONVERSION_AMOUNT"),
      value: `${parseFloat(conversion.amount).toFixed(2)} ${conversion.currency}`
    },
    {
      title: t("TYPE"),
      value: conversion.type
    },
    {
      title: t("CREATED_AT"),
      value: timeConverterMMDDYYHHMM(conversion.created_at)
    },
  ] : []

  const customerInfoData = conversion?.referral ? [
    {
      title: t("USERNAME"),
      value: '',
      custom: (
        <Link
          to={`/affiliate/customers/${conversion.referral.id}`}
          style={{color: '#3B82F6', textDecoration: 'none'}}
        >
          {conversion.referral.user?.full_name || '-'}
        </Link>
      )
    },
    {
      title: t("EMAIL"),
      value: conversion.referral.user?.email || '-',
      copy: true
    },
    {
      title: t("CUSTOMER_ID"),
      value: conversion.referral.user?.id || '-'
    },
    {
      title: t("COUNTRY"),
      value: conversion.referral.client?.country?.toUpperCase() || '-'
    },
  ] : []

  return (
    <Container>
      <BackArrow
        title={t("BACK_TO_CONVERSIONS")}
        onClick={() => navigate('/affiliate/conversions')}
      />
      {conversion && (
        <>
          <InfoBlock
            title={t("CONVERSION_DETAILS")}
            data={conversionInfoData}
          />
          {conversion.referral && (
            <InfoBlock
              title={t("CUSTOMER")}
              data={customerInfoData}
            />
          )}
        </>
      )}
    </Container>
  )
}

export default ConversionPage
